import React from 'react';
import Reveal from './Reveal';
import CaseStudyCard from './CaseStudyCard';
import { caseStudies } from '../data/site';

const Portfolio = () => (
  <section className="section">
    <div className="container">
      <Reveal className="work-grid">
        {caseStudies.map((project) => (
          <CaseStudyCard key={project.title} project={project} />
        ))}
      </Reveal>
    </div>
  </section>
);

export default Portfolio;
